import React, { useState } from 'react';

//Material
import {
  Avatar,
  Box,
  ClickAwayListener,
  Rating,
  styled,
  TextField,
  Typography
} from '@mui/material';
import { dateFormattingByDate } from '../helpers/date-helpers';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ReplyIcon from '@mui/icons-material/Reply';
import { setIsOpenDeleteModal } from '../redux/mainReducer';
import ApiService from '../helpers/apiHelper';
import EmojiPicker from 'emoji-picker-react';
import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined';
import { LetsGoBtn } from './Buttons';
import DefaultAvatar from '../assets/defaultPostImg.jpg';
import { Stack } from '@mui/system';

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#000000'
  },
  '& label': {
    color: '#7C7C7C',
    opacity: 1,
    fontFamily: 'FixelText-Regular'
  },
  '& .MuiInputBase-root': {
    alignItems: 'end',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
    borderRadius: '8px'
  },

  fontFamily: 'FixelText-Regular !important',
  margin: '5px 0px',

  '& ::placeholder': {
    color: '#7C7C7C',
    opacity: 1
  },

  '& .MuiInputBase-root.Mui-error': {
    backgroundColor: '#FFE5E5 !important'
  }
});

export default function RespondCard({
  setter,
  index,
  data,
  setToDelete,
  setModalText,
  serviceOwnerId,
  setIsCanWriteFeedback,
  ...props
}) {
  const apiFeedback = new ApiService('posts/feedback');
  const apiFeedbackResp = new ApiService('posts/feedback/add-feedback-answer');
  const apiFeedbackRespDelete = new ApiService('posts/feedback/delete-feedback-answer');
  // const apiFeedback = new ApiService('feedback');
  // const apiFeedbackResp = new ApiService('/feedback/add-feedback-answer');
  // const apiFeedbackRespDelete = new ApiService('/feedback/delete-feedback-answer');

  const [isShowResponseField, setIsShowResponseField] = useState(false);
  const [responseText, setResponseText] = useState('');
  const [isShowEmoji, setIsShowEmoji] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const language = useSelector((state) => state.Intl.locale);
  const userData = useSelector((state) => state.global.userData);

  const feedbackDelete = (id) => {
    apiFeedback.deleteItem(id).then((res) => setter());
    setIsCanWriteFeedback(true);
  };
  const responseDelete = (id) => {
    apiFeedbackRespDelete.deleteItem(id).then((res) => {
      setter();
    });
  };
  return (
    <Box
      sx={{
        boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
        backgroundColor: 'white',
        borderRadius: '8px',
        width: '100%',
        padding: { xs: '8px', sm: '24px' },
        position: 'relative'
      }}
    >
      {userData?.id === data?.userDTO?.id && (
        <DeleteOutlineOutlinedIcon
          onClick={() =>
            dispatch(
              setIsOpenDeleteModal({
                isOpen: true,
                text: 'цей відгук?',
                func: feedbackDelete,
                id: data.id
              })
            )
          }
          sx={{
            position: 'absolute',
            top: { xs: '8px', sm: '24px' },
            right: { xs: '8px', sm: '24px' },
            color: '#60A5DF',
            cursor: 'pointer',
            ':hover': {
              color: '#60A5DF'
            }
          }}
        />
      )}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'column'
        }}
      >
        <Stack
          flexDirection="row"
          sx={{
            backgroundColor: 'white',

            alignItems: 'center'
          }}
        >
          <Avatar
            src={data?.userDTO && data?.userDTO?.photoUrl ? data?.userDTO?.photoUrl : DefaultAvatar}
            onClick={() => navigate(`/${language}/user-page/${data.userDTO.id}?type=posts`)}
            sx={{
              width: { xs: 60, sm: 80 },
              height: { xs: 60, sm: 80 },
              border: 'none',
              mr: { xs: '8px', sm: '24px' },
              cursor: 'pointer',
              boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
              // boxShadow: blockedUsers.find(
              //   (user) => user.id === el?.userDTO?.id || user.id === el?.userRibbonDTO?.id
              // )
              //   ? '0px 0px 2px 2px rgba(255,0,0,1)'
              //   : 'none'
            }}
          />
          <Typography
            variant="subtitle"
            sx={{
              fontFamily: 'FixelText-Regular !important',
              fontSize: { xs: 14, sm: 16 },
              textAlign: 'left',
              cursor: 'pointer',
              fontWeight: '400',
              color: '#7C7C7C'
            }}
            onClick={() => navigate(`/${language}/user-page/${data.userDTO.id}?type=posts`)}
          >
            {`@${data?.userDTO && data.userDTO.nickname}`}
          </Typography>
        </Stack>

        <Typography
          sx={{
            fontSize: { xs: '16px', sm: '20px' },
            fontFamily: 'FixelText-Regular !important',
            fontWeight: '400',
            margin: '12px 0px !important',
            textAlign: 'left',
            wordBreak: 'break-word'
          }}
          children={data?.text
            .split('\r\n')
            .filter((el) => el.length !== 0)
            .map((string, index) => {
              return (
                <p key={index} style={{ margin: '0' }}>
                  {string}
                  <br />
                </p>
              );
            })}
        />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%'
          }}
        >
          {' '}
          <Rating
            sx={{ ml: '0px', mb: '12px' }}
            name="read-only"
            value={data?.rating}
            precision={0.5}
            readOnly
          />
          <Typography sx={{ color: '#868686', fontSize: '16px' }} variant="subtitle">
            {dateFormattingByDate(new Date(data?.creationTimeForFeedback))}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', width: 'fit-content' }}>
          {serviceOwnerId === userData?.id && !data?.answerFeedback && (
            <Box
              onClick={() => setIsShowResponseField(!isShowResponseField)}
              sx={{
                display: 'flex',
                justifyContent: 'left',
                alignItems: 'center',
                color: '#60A5DF',
                cursor: 'pointer'
              }}
            >
              <ReplyIcon
                sx={{
                  color: '#60A5DF',
                  cursor: 'pointer',
                  mr: '12px'
                }}
              />
              Відповісти
            </Box>
          )}
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        {isShowResponseField ? (
          <>
            {' '}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'end',
                position: 'relative',
                width: { xs: '100%', sm: '50%' },
                marginTop: '30px'
              }}
            >
              <CssTextField
                variant="outlined"
                placeholder="Надайте відповідь на цей відгук."
                multiline
                rows={8}
                fullWidth
                size="normal"
                inputProps={{ style: { textAlign: 'left' } }}
                InputProps={{
                  endAdornment: (
                    <>
                      <EmojiEmotionsOutlinedIcon
                        onClick={async () => {
                          setIsShowEmoji(!isShowEmoji);
                        }}
                        sx={{
                          display: { xs: 'none', md: 'inline-block' },
                          color: '#7C7C7C',
                          cursor: 'pointer',
                          fontSize: '20px',
                          mr: 1
                        }}
                      />
                    </>
                  )
                }}
                value={responseText}
                onChange={(event) => {
                  if (isShowEmoji) {
                    setIsShowEmoji(false);
                  }
                  if (event?.target?.value.length <= 500) setResponseText(event?.target?.value);
                  setError('');
                }}
              />
              {isShowEmoji && (
                <ClickAwayListener
                  onClickAway={() => {
                    setIsShowEmoji(false);
                  }}
                >
                  <Box>
                    <EmojiPicker
                      id="emogiPicker"
                      onEmojiClick={(emojiData, event) => {
                        let newStr = `${responseText}${emojiData?.emoji}`;
                        setResponseText(newStr);
                      }}
                      skinTonesDisabled
                      searchDisabled
                      previewConfig={{ showPreview: false }}
                      style={{
                        position: 'absolute',
                        bottom: error.length !== 0 ? '-200px' : '-220px',
                        right: '32px',
                        zIndex: '99'
                      }}
                      width={'50%'}
                      height={'300px'}
                    />
                  </Box>
                </ClickAwayListener>
              )}
              <p
                style={{ margin: '0 5px', color: '#7C7C7C', textAlign: 'left', fontSize: '14px' }}
              >{`${responseText.length} / 500`}</p>
              {error.length !== 0 && (
                <p
                  style={{ margin: '0 5px', color: 'red', textAlign: 'left', fontSize: '14px' }}
                >{`${error}`}</p>
              )}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  width: '100%',
                  alignItems: 'center',
                  gap: '12px',
                  mt: '12px'
                }}
              >
                <LetsGoBtn
                  colorScheme="blue"
                  text="Відправити"
                  width="100%"
                  marginTop="0px"
                  onClick={() => {
                    setIsShowEmoji(false);
                    if (responseText.length === 0) {
                      setError('Мінімальна довжина відповіді: 1 символ');
                    } else if (responseText.length > 500) {
                      setError('Максимальна довжина відповіді: 500 символів');
                    } else {
                      apiFeedbackResp
                        .updateDataID(data?.id, { answerText: responseText })
                        .then((res) => {
                          setter();
                          setIsShowResponseField(false);
                          setResponseText('');
                        });
                    }
                  }}
                />
                <LetsGoBtn
                  colorScheme="white"
                  text="Відхилити"
                  width="100%"
                  marginTop="0px"
                  o
                  onClick={() => {
                    setIsShowResponseField(false);
                    setIsShowEmoji(false);
                    setError('');
                    setResponseText('');
                  }}
                />
              </Box>
            </Box>
          </>
        ) : null}
        {data?.answerFeedback && (
          <div style={{ marginTop: '0px', paddingTop: '0px' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'left',
                alignItems: 'center',
                color: '#60A5DF'
              }}
            >
              <ReplyIcon
                sx={{
                  color: '#60A5DF',
                  cursor: 'pointer',
                  mr: '12px'
                }}
              />
              Відповідь продавця:
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Typography
                sx={{
                  fontSize: { xs: '16px', sm: '20px' },
                  fontFamily: 'FixelText-Regular !important',
                  fontWeight: '400',
                  margin: '12px 12px 12px 0px !important',
                  textAlign: 'left'
                }}
                children={data?.answerFeedback?.text
                  .split('\r\n')
                  .filter((el) => el.length !== 0)
                  .map((string, index) => {
                    return (
                      <p key={index} style={{ margin: '0' }}>
                        {string}
                        <br />
                      </p>
                    );
                  })}
              />
              {serviceOwnerId === userData?.id && data?.answerFeedback && (
                <DeleteOutlineOutlinedIcon
                  onClick={() =>
                    dispatch(
                      setIsOpenDeleteModal({
                        isOpen: true,
                        text: 'цю відповідь?',
                        func: responseDelete,
                        id: data?.id
                      })
                    )
                  }
                  sx={{
                    color: '#60A5DF',
                    cursor: 'pointer',
                    ':hover': {
                      color: '#60A5DF'
                    }
                  }}
                />
              )}
            </Box>
          </div>
        )}
      </Box>
    </Box>
  );
}
